var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "token-wrapper" }, [
    _c("div", { staticClass: "title" }, [
      _c("img", { attrs: { src: require("assets/imgs/eth_logo.svg") } }),
      _vm._v(_vm._s(_vm.token.symbol) + "\n    ")
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "content" }, [
      _c("div", { staticClass: "balance" }, [
        _vm._v("\n            " + _vm._s(_vm.$t("balance"))),
        _c("span", { staticClass: "num" }, [_vm._v(_vm._s(_vm.balance))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "btn-list" }, [
        _c(
          "div",
          {
            staticClass: "btn __pointer",
            class: _vm.classList,
            on: {
              click: function($event) {
                return _vm._sendTx("transfer", _vm.token.name)
              }
            }
          },
          [_vm._v(_vm._s(_vm.$t("sendTrans.symbol")))]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.token.symbol === "dSLS",
                expression: "token.symbol === 'dSLS'"
              }
            ],
            staticClass: "btn __pointer",
            class: _vm.classList,
            on: {
              click: function($event) {
                return _vm._sendTx("exchange", _vm.token.name)
              }
            }
          },
          [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$t("walletConversion.exchange.vite"))
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }